import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
  FormLabel
} from '@mui/material';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { getApi, patchApi } from 'views/services/api';
import { toast } from 'react-toastify';
import { Formik as formik } from 'formik';

const EditReservation = (props) => {
  const { open, handleClose, data } = props;

  const today = new Date().toISOString().split('T')[0];
  const [roomData, setRoomData] = useState([]);
  const user = JSON.parse(localStorage.getItem('hotelData'));

  const initialValues = {
    roomType: data?.roomType || 'default',
    roomNo: data?.roomNo || 'default',
    checkInDate: data?.checkInDate ? data.checkInDate.split('T')[0] : '',
    checkOutDate: data?.checkOutDate ? data.checkOutDate.split('T')[0] : '',
    advanceAmount: data?.advanceAmount || '',
    amount: data?.totalPayment || '',
    totalAmount: data?.totalPayment || '',
  };



    const fetchCustomerData = async (phoneNumber) => {
      try {
        // const response = await getApi(`api/customer/view/${phoneNumber}?hotelId=${hotel._id}`);
        const response = await getApi(`api/customer/view/${phoneNumber}?hotelId=${hotel?.hotelId}`);
        console.log('exsiting customer response -------------- ==>', response);
  
        setExistingCustomerData(response?.data?.customerData[0]);
        return response?.data?.customerData[0];
      } catch (error) {
        console.log(error);
      }
    };

  const fetchRoomData = async () => {
    try {
      const response = await getApi(`api/room/viewallrooms/${user?.hotelId}`);
      setRoomData(response?.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchRoomData();
  }, []);

  const handleTotalAmount = (advanceAmount) => {
    const totalAmt = formik.values.amount - (advanceAmount || 0);
    if (!isNaN(advanceAmount) && advanceAmount <= formik.values.amount) {
      formik.setFieldValue('advanceAmount', advanceAmount);
      formik.setFieldValue('totalAmount', totalAmt);
      formik.setFieldError('advanceAmount', '');
    } else {
      formik.setFieldValue('advanceAmount', '');
      formik.setFieldError('advanceAmount', 'Advance amount cannot exceed total amount');
    }
  };

  const calculateAmount = () => {
    const checkInDate = new Date(formik.values.checkInDate);
    const checkOutDate = new Date(formik.values.checkOutDate);
    let numberOfDays = Math.max(0, Math.ceil((checkOutDate - checkInDate) / (1000 * 3600 * 24)));

    if (numberOfDays == 0) {
      numberOfDays = 1
    }

    const selectedRoom = roomData.find((room) => String(room.roomNo) === formik.values.roomNo);
    if (selectedRoom) {
      const newAmount = selectedRoom.amount * numberOfDays;
      formik.setFieldValue('amount', newAmount);
      formik.setFieldValue('totalAmount', newAmount - (formik.values.advanceAmount || 0));
    }
  };



  const formik = useFormik({
    initialValues,
    validationSchema: yup.object({
      checkInDate: yup.date().required('Check-In Date is required'),
      checkOutDate: yup.date().required('Check-Out Date is required'),
      advanceAmount: yup
        .number()
        .integer('Advance Amount must be an integer')
        .required('Advance Amount is required'),
      totalAmount: yup.number().integer('Total Amount must be an integer'),
    }),
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      try {
        const response = await patchApi(`api/reservation/edit/${data?._id}`, values);
        if (response.status === 200) {
          toast.success('Reservation Successfully Modified');
          handleClose();
          resetForm();
          localStorage.setItem('modifiedDate', true);
        } else {
          toast.error('Failed to modify reservation');
        }
      } catch (e) {
        toast.error(e.response?.data?.error || 'An error occurred');
      }
    },
  });


  useEffect(() => {
    calculateAmount();
  }, [formik.values.checkInDate, formik.values.checkOutDate, formik.values.roomNo]);

  return (
    <Dialog open={open} aria-labelledby="scroll-dialog-title" aria-describedby="scroll-dialog-description">
      <DialogTitle
        id="scroll-dialog-title"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h6">Edit Room Reservation</Typography>
        <Button onClick={handleClose} style={{ color: 'red' }}>
          Cancel
        </Button>
      </DialogTitle>
      <DialogContent dividers>
        <form onSubmit={formik.handleSubmit}>
          <Typography style={{ marginBottom: '15px', marginTop: '15px' }} variant="h6">
            Room Information
          </Typography>
          <Grid container rowSpacing={3} columnSpacing={{ xs: 0, sm: 2 }}>
            
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <FormLabel>Room Number</FormLabel>
                <Select
                  id="roomNo"
                  name="roomNo"
                  size="small"
                  value={formik.values.roomNo}
                  onChange={(e) => {
                    formik.setFieldValue('roomNo', e.target.value);
                  }}
                >
                  <MenuItem value="default" disabled>
                    Select Room Number
                  </MenuItem>
                  {roomData.map((room) => (
                    <MenuItem key={room._id} value={room.roomNo}>
                      {room.roomNo}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText error={formik.touched.roomNo && formik.errors.roomNo}>
                  {formik.touched.roomNo && formik.errors.roomNo}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormLabel>Check-In Date</FormLabel>
              <TextField
                id="checkInDate"
                name="checkInDate"
                size="small"
                type="date"
                fullWidth
                value={formik.values.checkInDate}
                onChange={formik.handleChange}
                InputLabelProps={{ shrink: true }}
                disabled={new Date(formik.values.checkInDate) < new Date(today)}
                inputProps={{ min: today }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormLabel>Check-Out Date</FormLabel>
              <TextField
                id="checkOutDate"
                name="checkOutDate"
                size="small"
                type="date"
                fullWidth
                value={formik.values.checkOutDate}
                onChange={formik.handleChange}
                InputLabelProps={{ shrink: true }}
                inputProps={{ min: formik.values.checkInDate }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormLabel>Amount</FormLabel>
              <TextField
                id="amount"
                name="amount"
                size="small"
                type="text"
                fullWidth
                value={formik.values.amount}
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormLabel>Advance Amount</FormLabel>
              <TextField
                id="advanceAmount"
                name="advanceAmount"
                size="small"
                type="number"
                fullWidth
                value={formik.values.advanceAmount}
                onChange={(e) => handleTotalAmount(parseFloat(e.target.value))}
                error={formik.touched.advanceAmount && Boolean(formik.errors.advanceAmount)}
                helperText={formik.touched.advanceAmount && formik.errors.advanceAmount}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormLabel>Total Amount</FormLabel>
              <TextField
                id="totalAmount"
                name="totalAmount"
                size="small"
                type="text"
                fullWidth
                disabled
                value={`${user?.currencyCode || ''} ${formik.values.totalAmount}`}
              />
            </Grid>


          </Grid>


     
          <DialogActions>
            <Button type="submit" variant="contained" color="primary">
              Save Changes
            </Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  );
};

EditReservation.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  data: PropTypes.shape({
    _id: PropTypes.string,
    roomType: PropTypes.string,
    roomNo: PropTypes.string,
    checkInDate: PropTypes.string,
    checkOutDate: PropTypes.string,
    advanceAmount: PropTypes.number,
    totalPayment: PropTypes.number,
  }).isRequired,
};

export default EditReservation;
